import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalService } from '../services/global.service';
import { PagerService } from '../services/pager.service';
import { LoadingService } from '../shared/loading/loading.service';
import { Router } from '@angular/router';
import Utility from '../shared/utility';

@Component({
  selector: 'app-create-new-illustration',
  templateUrl: './create-new-illustration.component.html',
  styleUrls: ['./create-new-illustration.component.css']
})
export class CreateNewIllustrationComponent implements OnInit {
  @ViewChild('searchIconContainer') searchIconContainer: ElementRef;
  @ViewChild('clientSearch') clientSearch: ElementRef;
  @ViewChild('clientSearchBackButton') clientSearchBackButton: ElementRef;
  
  private navCards = [
    { title: 'From a Current Client', description: 'Search through clients to start your illustration from the Client Hub', urlOverride: '', icon: 'fa-ambulance', color: '#a4b7d6', iconColor: '#3385C5', image:'../../../assets/icons/magnifier.svg', isCreateReport:true },
    { title: 'Add New Client', description: 'Build a client profile (with optional spouse/partner) to run illustrations and reports', urlOverride: '/clients/create', icon: 'fa-university', color: '#bdaee0', iconColor: '#9578E3', image:'../../../assets/icons/new_client.svg', isCreateReport:true }
  ]
  data;
  displayClientSearch = false;
  isHVS: boolean = false;
  cloningClientId: number = null;
  private allItems: any[];
  pager: any = {};
  pagedItems: any[];

  private filteredClients: any;

  constructor(public dialogRef: MatDialogRef<CreateNewIllustrationComponent>, @Inject(MAT_DIALOG_DATA) data,
  private globalService: GlobalService, private pagerService: PagerService, private loadingService: LoadingService, private router: Router) { 
    //if being used as a dialog
    console.log('data from page ', data);
    //if(Object.keys(data).length > 0){
    if(data == true){
      this.data = data;
    }
  }

  ngOnInit() {
    this.isHVS = Number(localStorage.getItem('roleId')) === 1 && Number(localStorage.getItem('orgID')) === 1;
    this.getClients();
  }

  close(){
    this.dialogRef.close();
  }

  controlPage(title) {
    //if being used as a dialog
    if(this.data){
      if(title == 'Add New Client'){
        this.dialogRef.close();
      }
    } 
    
    if (title == 'From a Current Client') {
      //display client/client search
      if(!this.allItems){
        this.loadingService.isLoading(true);
      }
      
      this.displayClientSearch = true;
    }
  }

  backToCardDisplay(){
    this.displayClientSearch = false;
  }

  setPage(page: number) {
    if (this.filteredClients.length === 1) {
      this.pagedItems = this.filteredClients;
      this.pager = this.pagerService.getPager(this.filteredClients.length, page);
      return;
    }

    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    // get pager object from service
    // this.pager = this.pagerService.getPager(this.allItems.length, page);
    this.pager = this.pagerService.getPager(this.filteredClients.length, page);

    // get current page of items
    this.pagedItems = this.filteredClients.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  selectClient(e, client){
    localStorage.setItem('selectedClient', client.ID);
    localStorage.setItem('selectedAdvisor', client.AdvisorName);
    localStorage.setItem('selectedAdvisorID', client.AdvisorID);
    localStorage.setItem('selectedAdvisorOrgID', client.AdvisorOrgID);
    
    //this.router.navigate(['/clients/edit']);
    if(!client.HasRanMiniQuestionnaire){
      this.router.navigate(['/reports/new']);
    } else {
      //else, send to Client Hub
      this.router.navigate(['/clients/edit']);
    }

    if(this.data){
      this.dialogRef.close();
    }
  }

  getClients() {
    //this.loadingService.isLoading(true);
    this.globalService.getClientsData()
      .subscribe(
        clients => {
          console.log('clients', clients);
          var spouses;
          this.allItems = clients.map((item) => {
            spouses = JSON.parse(item.cp.Spouses) || [];

            if (item.c) {
              item.c.OrganizationName = item.o ? item.o.Name : '';
              //item.c.HasRanMiniQuestionnaire = (item.cp.CoverageType || item.cp.ClientMetroArea || item.cp.PIA);
              item.c.HasRanMiniQuestionnaire = (item.cp.CoverageType || item.cp.ClientMetroArea || item.cp.SSDesiredAgeYears || item.cp.MonthlyBenefitAmount || item.cp.PIA || item.cp.CurrentIncome > 0) ? true : false;
              //item.c.CoverageType = item.cp.CoverageType;
              //item.c.ClientMetroArea = item.cp.ClientMetroArea;

              spouses.map((spouse) => {
                if (spouse && spouse.maritalStatus == 'Married') {
                  item.c.spouseName = spouse.firstName + " " + spouse.lastName;
                }
              });

              if (item.a) {
                item.c.AdvisorName = item.a.FirstName + " " + item.a.LastName;
                item.c.AdvisorID = item.a.ID;
                item.c.AdvisorOrgID = item.a.OrganizationID;
              }

              return item.c;
            } else {
              return item
            }
          });
          this.filteredClients = this.allItems;

          this.filteredClients = this.allItems.sort(function (a, b) {
            return parseInt(b.ID) - parseInt(a.ID);
          });
          this.setPage(1);
          this.loadingService.isLoading(false);
        },
        error => {
          //this.error = <any>error
          //this.loadingService.isLoading(false);
        });
  }

  cloneClient(event, client) {
    event.stopPropagation();
    if (this.cloningClientId) { return; }
    this.cloningClientId = client.ID;

    this.globalService.getClientData(client.ID, 4)
      .subscribe(
        data => {
          const UserModel = {
            AdvisorID: Number(localStorage.getItem('userId')),
            OrganizationID: Number(localStorage.getItem('orgID')),
            ID: 0,
            Username: data.client.Email,
            Email: data.client.Email,
            FirstName: data.client.FirstName + ' (Copy)',
            LastName: data.client.LastName,
            Address: data.client.Address,
            City: data.client.City,
            State: data.client.State,
            Zip: data.client.Zip,
            Phone: data.client.Phone,
            DOB: data.client.DOB,
            GenderID: Number(data.client.GenderID),
            ProgramFeePercent: data.client.ProgramFeePercent
          };

          const cp = data.clientProfile;
          cp.ClientID = 0;

          const RiskTolerance = {
            ClientID: 0,
            FinancialObjID: null,
            LvlOfInvestExpID: null,
            LngthOfInvestID: null,
            ToleranceOfRiskID: null,
            NeedRedeemID: null,
            AccountType: null,
            HasSignedAdvisoryAgreement: false,
            HasSignedUpForManagedAccount: false
          };

          this.globalService.createClient(UserModel, cp, RiskTolerance)
            .subscribe(
              resp => {
                this.cloningClientId = null;
                if (resp.error === 0) {
                  this.getClients();
                }
              },
              error => {
                this.cloningClientId = null;
              }
            );
        },
        error => {
          this.cloningClientId = null;
        }
      );
  }

  filterItem(value) {
    this.filteredClients = Object.assign([], this.allItems).filter(
      advisor => {
        return (advisor.FirstName + " " + advisor.LastName + " " + advisor.spouseName).toLowerCase().includes(value.toLowerCase()) || (advisor.AdvisorName).toLowerCase().includes(value.toLowerCase()) || (advisor.OrganizationName).toLowerCase().includes(value.toLowerCase())
      }
    );

    if (!this.filteredClients.length) {
      this.pagedItems = [];
    } else {
      this.setPage(1);
    }
  }

  formatDate(date) {
    date = new Date(date);
    return date > 1 / 1 / 1900 ? (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear() + ' ' + Utility.parseDateTime(date) : '--';
  }
}
